export { VerticalVideo, type VerticalVideoProps } from "./VerticalVideo";
